import Vue from 'vue'
import VueRouter from 'vue-router'
import main from './main'
import petrifaction from './petrifaction'
import policy from './policy'
Vue.use(VueRouter)
let routes = new Set([...main,...petrifaction,...policy])
routes.add({
    path: '*',
    component: () =>
        import ('@/views/404.vue')
})

const router = new VueRouter({
    routes,
    mode: 'history'
})

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
    document.documentElement.scrollTop = 0
    next()
});
export default router